import styled from "@emotion/styled";
import React from "react";
import { Fragment } from "react";

const Rupees = (props) => {
  const { rate } = props;
  return (
    <Fragment>
      <RupeeSymbolWrapper>₹ </RupeeSymbolWrapper>
      {rate}
    </Fragment>
  );
};

export default Rupees;

const RupeeSymbolWrapper = styled.span`
  font-family: Roboto;
  
`;
